module.exports = __webpack_public_path__ + "img/图片5.2943c7b3.png";